import { Schema as S } from "effect";
import * as AliasId from "./AliasId";
export const Schema = S.String.pipe(S.minLength(1), S.maxLength(255), S.brand("@open-revenue/schema/AppUserId"), S.annotations({
    description: "A unique identifier for a user of the app, supplied by the developer"
}));
export const Type = Schema.Type;
export const make = (id)=>S.decodeUnknown(Schema)(id);
export const makeUnsafe = (id)=>id;
export const OrAliasIdSchema = S.Union(Schema, AliasId.Schema);
